import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=2766e52a&scoped=true&"
import script from "./text-input.vue?vue&type=script&lang=ts&"
export * from "./text-input.vue?vue&type=script&lang=ts&"
import style0 from "./text-input.vue?vue&type=style&index=0&id=2766e52a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766e52a",
  null
  
)

export default component.exports